<template>
  <div class="value">
    <svg style="display: none;">
      <symbol id="value-2" viewBox="0 0 43.62 33.72">
        <path d="M21.44,21.76l-1.79-1.2c2.81-4.28,5.8-6.9,11.46-6.9,5.47,0,9.57,3.82,9.57,8.88,0,4.46-2.39,7.41-8.05,12.56L22.78,44H41v2.3H19V44.54L31,33.68c5.29-4.83,7.13-7.59,7.13-11,0-4.19-3.4-6.9-7.27-6.9C26.78,15.78,24.11,17.9,21.44,21.76Z" transform="translate(-8.19 -13.14)"/>
      </symbol>
      <symbol id="value-3" viewBox="0 0 43.62 33.72">
        <path d="M20.5,15.88V13.62H40.65v1.7L29.75,27.79c6.12.37,11.41,3.22,11.41,9.16,0,5.66-4.92,9.43-10.49,9.43a14.49,14.49,0,0,1-11.82-5.8l1.84-1.52a12.26,12.26,0,0,0,10,5.15c4.33,0,8-2.9,8-7.18,0-4.55-4.23-7-10-7H26.89l-.6-1.33L37.38,15.88Z" transform="translate(-8.19 -13.14)"/>
      </symbol>
      <symbol id="value-4" viewBox="0 0 43.62 33.72">
        <path d="M37.66,13.78v22.5H42.9v2.07H37.66v7.87h-2.3V38.35H17.92l-.83-1.79L35.5,13.78Zm-2.3,3.45L20,36.28H35.36Z" transform="translate(-8.19 -13.14)"/>
      </symbol>
      <symbol id="value-5" viewBox="0 0 43.62 33.72">
        <path d="M21.74,13.62H39.82v2.3h-16L23.08,28a15.11,15.11,0,0,1,7.13-1.75c6.21,0,11,4,11,9.75,0,6.12-4.74,10.4-11.23,10.4-4.37,0-8.46-2.35-11.27-5.2l1.7-1.7c2.9,2.9,6.26,4.74,9.66,4.74,5.11,0,8.65-3.59,8.65-8.14s-3.63-7.68-8.83-7.68a14.54,14.54,0,0,0-7.27,2l-1.84-1.2Z" transform="translate(-8.19 -13.14)"/>
      </symbol>
      <symbol id="value-6" viewBox="0 0 43.62 33.72">
        <path d="M39.11,18.91c-2.48-2.21-4.92-3.4-8-3.4-6.53,0-10.76,6.85-10.54,16.7a11.1,11.1,0,0,1,10.08-6c5.94,0,11.09,4,11.09,9.8,0,6.16-4.92,10.63-11.27,10.63a11.61,11.61,0,0,1-8.19-3.22c-2.67-2.67-4.09-5.89-4.09-12.61,0-9.75,5.11-17.48,13.11-17.48,3.68,0,6.49,1.43,9.29,3.73Zm-8.56,9.43c-5.29,0-9,4-9,8,0,4.65,3.91,8.14,9.11,8.14a8.23,8.23,0,0,0,8.6-8.37C39.29,31.66,35.66,28.34,30.55,28.34Z" transform="translate(-8.19 -13.14)"/>
      </symbol>
      <symbol id="value-7" viewBox="0 0 43.62 33.72">
        <path d="M19.33,13.9H40.67v1.75L26,46.1H23.38L38,16.2H19.33Z" transform="translate(-8.19 -13.14)"/>
      </symbol>
      <symbol id="value-8" viewBox="0 0 43.62 33.72">
        <path d="M30,46.56c-6.76,0-12-3.73-12-9.11,0-3.82,3.08-6.67,7.13-8-3.17-1.29-6-3.68-6-7.54,0-5.06,5.29-8.46,10.86-8.46s10.86,3.4,10.86,8.46c0,3.86-2.85,6.26-6,7.54,4,1.33,7.13,4.19,7.13,8C42,42.84,36.76,46.56,30,46.56Zm0-16c-5.25,0-9.48,2.9-9.48,6.95,0,3.68,3.54,6.86,9.48,6.86s9.48-3.17,9.48-6.86C39.48,33.5,35.24,30.6,30,30.6Zm0-15c-4.69,0-8.37,2.62-8.37,6.3,0,4,3.82,6.67,8.37,6.67s8.37-2.67,8.37-6.67C38.37,18.22,34.69,15.6,30,15.6Z" transform="translate(-8.19 -13.14)"/>
      </symbol>
      <symbol id="value-9" viewBox="0 0 43.62 33.72">
        <path d="M28.67,46.65c-4,0-7-1.75-9.71-4l1.52-1.84c2.71,2.44,5.29,3.68,8.24,3.68,6.49,0,11-6.95,10.67-16.61-1.84,3.31-5,6.21-10,6.21-6.49,0-11.13-4.32-11.13-9.89,0-6,4.6-10.86,11.32-10.86a11.39,11.39,0,0,1,8.19,3.27c2.58,2.58,4,6.12,4,12.61C41.78,39.39,36.17,46.65,28.67,46.65Zm.6-31.15a8.38,8.38,0,0,0-8.56,8.6c0,4.55,3.63,7.87,8.74,7.87,5.47,0,9-4.14,9-8.23C38.42,19.14,34.6,15.51,29.26,15.51Z" transform="translate(-8.19 -13.14)"/>
      </symbol>
      <symbol id="value-T" viewBox="0 0 43.62 33.72">
        <path d="M15.55,13.67h1.84V46.1H15V16.15L8.84,18.27l-.64-1.89Z" transform="translate(-8.19 -13.14)"/>
        <path d="M38.42,46.65c-8.19,0-13.3-7.68-13.3-16.61s5.2-16.7,13.39-16.7S51.81,21,51.81,30,46.61,46.65,38.42,46.65Zm0-31.15c-6.67,0-10.81,6.9-10.81,14.45s4.23,14.54,10.9,14.54S49.32,37.59,49.32,30,45.09,15.51,38.42,15.51Z" transform="translate(-8.19 -13.14)"/>
      </symbol>
      <symbol id="value-J" viewBox="0 0 43.62 33.72">
        <path d="M30.11,46.33c-4.78,0-7.77-2.48-9.75-6l2-1.24c2,3.36,4.14,5.11,7.91,5.11,4,0,7-3,7-8.6V13.67h2.39V35.38C39.64,42.61,35.45,46.33,30.11,46.33Z" transform="translate(-8.19 -13.14)"/>
      </symbol>
      <symbol id="value-Q" viewBox="0 0 43.62 33.72">
        <path d="M44.68,46.86l-4.51-4.09a15.8,15.8,0,0,1-10.4,3.68c-9.75,0-16.15-7.77-16.15-16.56v-.09c0-8.79,6.49-16.65,16.24-16.65S46,20.91,46,29.7c0,0,0,0,0,.09a17,17,0,0,1-4.23,11.36L46.38,45ZM43.53,29.79c0-8-5.8-14.49-13.75-14.49S16.11,21.74,16.11,29.7v.09c0,8,5.8,14.49,13.76,14.49a13.19,13.19,0,0,0,8.56-3l-6.26-5.34L33.86,34,40,39.64a15,15,0,0,0,3.5-9.75Z" transform="translate(-8.19 -13.14)"/>
      </symbol>
      <symbol id="value-K" viewBox="0 0 43.62 33.72">
        <path d="M40.26,46.1,27,29.82l-8,8.1V46.1H16.61V13.9H19V35.06L39.52,13.9h3.27L28.71,28.11l14.68,18Z" transform="translate(-8.19 -13.14)"/>
      </symbol>
      <symbol id="value-A" viewBox="0 0 43.62 33.72">
        <path d="M43.53,46.22l-4.09-9h-19l-4.09,9H13.85l15-32.43h2.3l15,32.43ZM30,16.41,21.44,35h17Z" transform="translate(-8.19 -13.14)"/>
      </symbol>
    </svg>
    <svg v-if="value" fill="currentColor" :class="suitColor">
      <use :xlink:href="'#value-' + value"></use>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      validator: value => (typeof value === 'string' && value.length === 1) || value === null
    },
    suit: {
      required: true,
      validator: value => (typeof value === 'string' && value.length === 1) || value === null
    }
  },
  computed: {
    suitColor () {
      if (['C', 'S'].includes(this.suit)) return 'white--text'
      return 'red--text'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/../sass/_variables.scss';

.value svg {
  width: 2em;
  height: 2em;
}

@media screen and (max-width: $playing-card-sm-breakpoint) {
  .value svg {
    width: 1.5em;
    height: 1.5em;
  }
}
</style>
